<template>
    <div id="app" class="wrap">
        <main-header :mobileWidth="mobileWidth"></main-header>
        <div class="view-content">
            <router-view :mobileWidth="mobileWidth"></router-view>
        </div>
        <main-footer :class="{'order-display': isOrder}"></main-footer>
        <main-side v-show="!mobileWidth"></main-side>
    </div>
</template>

<script>
import MainHeader from './components/common/header.vue';
import MainFooter from './components/common/footer.vue';
import MainSide from './components/common/side.vue';

export default {
    name: 'main-index',
    data() {
        return {
            keyWord: '',
            screenWidth: document.body.clientWidth,
            widthTimer: false,
            applet: '',
        };
    },
    components: {
        MainHeader,
        MainFooter,
        MainSide
    },
    computed: {
        mobileWidth() {
            return this.screenWidth <= 480;
        },
        isOrder() {
            return this.$route.name === 'order';
        }
    },
    watch: {
        screenWidth(val){
            // 为了避免频繁触发resize函数导致页面卡顿，防抖
            if(!this.widthTimer){
                this.screenWidth = val;
                this.widthTimer = true;
                setTimeout(() => {
                    this.widthTimer = false;
                }, 400);
            }
        }
    },
    created() {
        // 识别移动端跳转
        if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) && !(window.location.href.includes('applet=1'))) {
            document.location.href = 'http://www.annto.com/index';
        }
        this.applet = window.location.href.includes('applet=1') ? 1 : '';
        this.applet && sessionStorage.setItem('my_applet',this.applet);
    },
    mounted() {
        window.addEventListener('resize', () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })();
        });
    }
};
</script>
<style lang="less">
@media screen and (max-width: 480px) {
    .view-content {
        margin-top: 0.45rem;
    }
    .order-display {
        display: none !important;
    }
}
</style>

